import { render, staticRenderFns } from "./VehicleListModal.vue?vue&type=template&id=20e23d3b&scoped=true&"
import script from "./VehicleListModal.vue?vue&type=script&lang=js&"
export * from "./VehicleListModal.vue?vue&type=script&lang=js&"
import style0 from "./VehicleListModal.vue?vue&type=style&index=0&id=20e23d3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e23d3b",
  null
  
)

export default component.exports